/**
 * @export
 * Placeholder component for declarative field definition.
 * This component doesn't render anything - it's only used to extract props
 * in the parent DataEntryForm component.
 *
 * @example
 * ```tsx
 * <DataEntryField
 *   field="email"
 *   title="Email Address"
 *   type="email"
 *   icon="fas at"
 *   required
 *   validate={async (val) => ({
 *     valid: val.includes('@'),
 *     error: 'Invalid email'
 *   })}
 * />
 * ```
 */
export const DataEntryField = () => {
    return null;
};
